import { fetchPageAssets } from '../../ducks/hostedAssets.duck';
import { searchListings } from '../SearchPage/SearchPage.duck';
import { getHomePageListingsById } from '../../ducks/marketplaceData.duck';
import { createImageVariantConfig } from '../../util/sdkLoader';

export const ASSET_NAME = 'landing-page';

export const loadData = (params, search) => dispatch => {
  const pageAsset = { landingPage: `content/pages/${ASSET_NAME}.json` };
  return dispatch(fetchPageAssets(pageAsset, true));
};

// Fetch latest listings
export const fetchLatestListings = config => {
  const { aspectWidth = 1, aspectHeight = 1, variantPrefix = 'listing-card' } = config.layout.listingImage;
  const aspectRatio = aspectHeight / aspectWidth;

  return async (dispatch, getState) => {
    try {
      // Fetch listings from search API
      const params = {
        perPage: 40,
        include: ['author', 'images'],
        'fields.listing': [
          'title',
          'price',
          'deleted',
          'state',
          'publicData.transactionProcessAlias',
        ],
        'fields.user': ['profile.displayName', 'profile.abbreviatedName'],
        'fields.image': [
          'variants.scaled-small',
          'variants.scaled-medium',
          `variants.${variantPrefix}`,
          `variants.${variantPrefix}-2x`,
        ],
        ...createImageVariantConfig(variantPrefix, 400, aspectRatio),
        ...createImageVariantConfig(`${variantPrefix}-2x`, 800, aspectRatio),
        'limit.images': 1,
      };

      const response = await dispatch(searchListings(params, config));

      if (response.data && Array.isArray(response.data.data)) {
        const listingIds = response.data.data.map(listing => listing.id.uuid); // Extract UUIDs

        // Check if listings are already in state
        const state = getState();
        const existingListings = listingIds.map(id => state.marketplaceData.entities.listing[id]);

        // If not found in state, log an error
        if (existingListings.some(listing => !listing)) {
          console.error("Some listings are not found in state. Ensure they are fetched and stored.");
          return []; // or handle this case as needed
        }
        
        const detailedListings = getHomePageListingsById(state, listingIds);
        
        // Map images from included array to listings
        const includedImages = response.data.included.filter(item => item.type === "image");

        detailedListings.forEach(listing => {
          if (listing.relationships && listing.relationships.images && listing.relationships.images.data) {
            listing.images = listing.relationships.images.data.map(imageRef => {
              return includedImages.find(image => image.id === imageRef.id);
            }).filter(image => image); // Filter out any undefined values
          }
        });

        // Dispatch success action with wrapped payload
        dispatch({
          type: 'FETCH_LISTINGS_DETAILS_SUCCESS',
          payload: { listings: detailedListings },
        });

        return detailedListings; // Return for local use
      }
    } catch (error) {
      console.error("Error in fetchLatestListings:", error);
      return [];
    }
  };
};


// Fetch edits listings
export const fetchEditsListings = config => {
  const { aspectWidth = 1, aspectHeight = 1, variantPrefix = 'listing-card' } = config.layout.listingImage;
  const aspectRatio = aspectHeight / aspectWidth;

  return async (dispatch, getState) => {
    try {
      // Fetch listings from search API
      const params = {
        keywords: "festival",
        perPage: 40,
        include: ['author', 'images'],
        'fields.listing': [
          'title',
          'price',
          'deleted',
          'state',
          'publicData.transactionProcessAlias',
          'publicData.festival'
        ],
        'fields.user': ['profile.displayName', 'profile.abbreviatedName'],
        'fields.image': [
          'variants.scaled-small',
          'variants.scaled-medium',
          `variants.${variantPrefix}`,
          `variants.${variantPrefix}-2x`,
        ],
        ...createImageVariantConfig(variantPrefix, 400, aspectRatio),
        ...createImageVariantConfig(`${variantPrefix}-2x`, 800, aspectRatio),
        'limit.images': 1,
      };

      const response = await dispatch(searchListings(params, config));

      if (response.data && Array.isArray(response.data.data)) {
        const listingIds = response.data.data.map(listing => listing.id.uuid); // Extract UUIDs

        // Check if listings are already in state
        const state = getState();
        const existingListings = listingIds.map(id => state.marketplaceData.entities.listing[id]);

        // If not found in state, log an error
        if (existingListings.some(listing => !listing)) {
          console.error("Some listings are not found in state. Ensure they are fetched and stored.");
          return []; // or handle this case as needed
        }
        
        const detailedListings = getHomePageListingsById(state, listingIds);
        
        // Map images from included array to listings
        const includedImages = response.data.included.filter(item => item.type === "image");

        detailedListings.forEach(listing => {
          if (listing.relationships && listing.relationships.images && listing.relationships.images.data) {
            listing.images = listing.relationships.images.data.map(imageRef => {
              return includedImages.find(image => image.id === imageRef.id);
            }).filter(image => image); // Filter out any undefined values
          }
        });

        // Dispatch success action with wrapped payload
        dispatch({
          type: 'FETCH_LISTINGS_DETAILS_SUCCESS',
          payload: { listings: detailedListings },
        });

        return detailedListings; // Return for local use
      }
    } catch (error) {
      console.error("Error in fetchLatestListings:", error);
      return [];
    }
  };
};


